import type { ErrorMap } from "@repo/shared/common";

export function areBoundFieldPropsEqual<
	P extends {
		errorKey?: string;
		errors?: ErrorMap;
	},
>(prev: P, next: P): boolean {
	// Special case: compare errors only for the relevant error key
	const prevError = prev.errors?.[prev.errorKey ?? ""];
	const nextError = next.errors?.[next.errorKey ?? ""];

	if (prevError !== nextError) return false;

	// 2) Shallow Compare über alle anderen Props
	const prevKeys = Object.keys(prev) as (keyof P)[];
	const nextKeys = Object.keys(next) as (keyof P)[];

	if (prevKeys.length !== nextKeys.length) return false;

	for (const key of prevKeys) {
		// errors separat behandelt → überspringen
		if (key === "errors" || key === "errorKey") continue;

		if (prev[key] !== next[key]) return false;
	}

	return true;
}
